import * as types from '../constants';

const initialState = {
  staffListTotal: 0,
  staffListItems: [],
  currentPageNumber: 1,
  paginationItem: {
    offset: 0,
    limit: 10,
  },
  filterItem: {
    name: '',
    role: '',
    status: '',
  },
};

const StaffListReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.INIT_STAFF_LIST_STATE:
      return {
        ...state,
        staffListTotal: 0,
        staffListItems: [],
        currentPageNumber: 1,
        paginationItem: {
          offset: 0,
          limit: 10,
        },
        filterItem: {
          name: '',
          role: '',
          status: '',
        },
      };
    case types.SET_STAFF_LIST:
      return {
        ...state,
        staffListTotal: action.payload.total,
        staffListItems: action.payload.items,
      };
    case types.SET_STAFF_LIST_CURRENT_PAGE_NUMBER:
      return {
        ...state,
        currentPageNumber: action.payload,
      };
    case types.SET_STAFF_PAGINATION_ITEM:
      return {
        ...state,
        paginationItem: action.payload,
      };
    case types.SET_STAFF_FILTER_ITEM:
      return {
        ...state,
        filterItem: action.payload,
      };
    default:
      return state;
  }
};

export default StaffListReducer;